import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

import { Glyphicon } from "../Glyphicon/Glyphicon";
import ConservatoryImage from "../ConservatoryImage/ConservatoryImage";

import { _CloseButton as CloseButton, _Content as Content } from "./style";

export const PreviewLightbox = ({ isOpen, onClose, frameType, smaller }) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onClose}
    appElement={document.getElementById("bfc-single-page-app")}
    className="preview-lightbox"
    overlayClassName="preview-lightbox-overlay"
  >
    <CloseButton onClick={onClose} data-id="PreviewLightbox__CloseButton">
      <Glyphicon name="circle-remove" />
    </CloseButton>
    <Content>
      <ConservatoryImage
        variant="lightbox"
        frameType={frameType}
        smaller={smaller}
      />
    </Content>
  </ReactModal>
);

PreviewLightbox.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  frameType: PropTypes.string,
  smaller: PropTypes.bool,
};
